import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/uniregistry': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M281.1 220.1H384V205.3H281.1V220.1zM281.1 183H384V170.6H281.1V183zM281.1 257.2H384V239.9H281.1V257.2zM123.4 343.9H8.5C11.1 352.4 14.3 360.7 18.1 368.7H156.4C143.5 363 132.3 354.5 123.4 343.9M269.1 331.5H378.8C380.6 324.2 381.9 316.8 382.7 309.2H278.3C276.2 317.1 273.1 324.6 269.1 331.5M227.6 368.6H367C370.7 360.6 372.8 352.4 375.5 343.8H260.5C251.7 354.5 240.4 363 227.6 368.6M384 32H281.1V34.5H384V32zM192 480C231.5 480 268.2 468.2 298.8 447.8H85.3C115.8 468.2 152.5 480 192 480M281.1 145.8H384V136H281.1V145.8zM281.1 108.7H384V101.3H281.1V108.7zM281.1 71.6H384V66.7H281.1V71.6zM102.9 170.6H0V183H102.9V170.6zM38.8 405.7H344.1C350.8 397.2 356.7 388.1 361.9 378.5H23C28.2 388.1 32.2 397.2 38.8 405.7M102.9 286.9V274.5H0V286.9C0 289.4 0 291.9 0.1 294.3H103.2C103 291.9 102.9 289.4 102.9 286.9M281.1 286.9C281.1 289.4 281 291.9 280.7 294.3H383.8C383.9 291.8 384 289.4 384 286.9V274.5H281.1V286.9zM78.1 442.9H305.8C317.6 434.2 328.5 424.3 338 413.2H44.9C54.5 424.2 66.3 434.2 78.1 442.9M102.9 66.7H0V71.6H102.9V66.7zM102.9 32H0V34.5H102.9V32zM102.9 205.3H0V220.1H102.9V205.3zM102.9 239.9H0V257.2H102.9V239.9zM102.9 136H0V145.9H102.9V136zM102.9 101.3H0V108.7H102.9V101.3zM105.7 309.2H1.3C2.2 316.8 3.5 324.2 5.2 331.5H114.9C110.9 324.6 107.7 317.1 105.7 309.2'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/uniregistry.js
// module id = +ydm
// module chunks = 144